// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1USW3","header":"MessagesList_header__v13oI","chat":"MessagesList_chat__3Ozdu"};